//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import articleStats from '~/mixins/articleStats.js'

export default {
  mixins: [articleStats],
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    text: {
      type: String,
      required: false,
      default: null,
    },
    link: {
      type: String,
      default: '/',
    },
    image: {
      type: Object,
      default() {
        return {
          src: '',
          width: 390,
          height: 250,
          alt: '',
        }
      },
    },
    type: {
      type: String,
      default: 'TeaserArticle',
    },
    tags: {
      type: Array,
      default() {},
    },
  },

  computed: {
    url() {
      const topic = this.$route.params.topic
      return this.link
        ? this.$localeResolver.localePath(`/learn/${topic}/${this.link}`)
        : null
    },
  },
}
